export const studentMessages = {
    "birthDate": "Date of birth",
    "branchOfService": "Branch of service",
    "collegeName": "University / College name",
    "companyName": null,
    "dateTime": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December",
        "month": "Month",
        "day": "Day",
        "year": "Year"
    },
    "emailAddress": "Email address",
    "returnToWSJ": "CONTINUE",
    "error": "Error",
    "firstName": "First name",
    "howDoesReviewWork": "How does review work?",
    "howDoesVerifyingWork": "How does verifying work?",
    "lastName": "Last name",
    "loading": "Loading...",
    "militaryStatus": "Military status",
    "noOptions": "No options",
    "personalInformation": "Personal Information",
    "personalOrSchoolIsFine": "Personal or school email is fine",
    "postalCode": "Postal code",
    "poweredBy": "Verification services powered by SheerID",
    "requiredFields": "All fields are required",
    "school": "School",
    "schoolName": "School Name",
    "sheerIdFaqs": "SheerID FAQs",
    "studentInfoShared": "Information entered into this web form will be used for verification purposes. The information will be shared with {companyName}.",
    "universityName": "University name",
    "verifyAndContinue": "Verify and continue",
    "verificationPurposesOnly": "Used for verification purposes only",
    "errorId": {
        "internalServerError": "Internal server error",
        "noProgram": "No program found",
        "noVerification": "No verification found",
        "invalidProgram": "Invalid program",
        "invalidStep": "Invalid step",
        "invalidMilitaryStatus": "Invalid military status, expected one of [ACTIVE_DUTY, VETERAN, RESERVIST, MILITARY_RETIREE]",
        "invalidFirstResponderStatus": "Invalid first responder status, expected one of [POLICE, EMT, FIREFIGHTER]",
        "invalidOrganization": "You must select an organization from the list",
        "invalidFirstName": "Invalid first name",
        "invalidLastName": "Invalid last name",
        "invalidBirthDate": "Invalid birth date",
        "invalidEmail": "Invalid email",
        "invalidPostalCode": "Invalid postal code",
        "underagePerson": "Underage",
        "outsideAgePerson": "Age outside allowed range",
        "futureBirthDate": "Future birthdate",
        "unsupportedDocMimeType": "One or more files is an unsupported format",
        "invalidFileSizeEmpty": "One or more files is empty",
        "invalidFileSizeMax": "One or more files is too large (max: 10MB)",
        "invalidNumberOfFiles": "Maximum number of files exceeded (max: 5)",
        "invalidDocUploadToken": "Provided document upload token is not valid",
        "verificationLimitExceeded": "Verification limit exceeded",
        "docReviewLimitExceeded": "Document review limit exceeded",
        "maxMetadataValuesExceeded": "Maximum number of metadata values exceeded",
        "maxMetadataLengthExceeded": "Maximum length of metadata value exceeded",
        "unknownError": "Unknown Error",
        "invalidRequest": "Invalid request",
        "invalidApiToken": "Provided API token was invalid or empty",
        "simulatedError": "This is a simulated error",
        "notFound": "Not found"
    },
    "step": {
        "personalInfo": {
            "subtitle": "Verify you're a student at a degree-granting university.",
            "title": "Unlock this Student-Only Offer",
            "howDoesVerifyingWorkDetails": "To be eligible for this offer, you must currently be enrolled in a United States-based, degree-granting, Title IV-accreditted school of higher education.<br/><br/>{companyName} uses SheerID, a trusted partner, to verify that you are a current student. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.",
            "countries": {
                "US": "United States"
            },
            "locales": {
                "en-US": "English"
            }
        },
        "docUpload": {
            "acceptableUploads": {
                "student": {
                    "idCard": "School ID card with expiration date",
                    "classSchedule": "Class schedule",
                    "tuitionReceipt": "Tuition receipt",
                },
            },
            "uploadInfo": {
                "fullName": "Your full name",
                "student": {
                    "school": "Your School",
                    "enrollmentDate": "Date that proves current enrollment <span class='sid-wrap'>(or within last 3 months)</span>"
                },
            },
            "acceptedTypes": "Files must be .jpg .png  .pdf .gif or .bmp",
            "verificationTitle": "STUDENT VERIFICATION",
            "title": "We need some additional information to verify that you are a student.",
            "subtitle": "Documents will be reviewed in a few minutes.",
            "footer": null,
            "fileInstructions": 'Drag and drop your files here or <span class="sid-dropzone-wrap--link">browse</span>',
            "submitButtonLabel": "SUBMIT",
            "howDoesReviewWorkDetails": "Document review is handled by SheerID, a trusted partner who specializes in verifying students.<br/><br/>Documents are used only for verifying your student status is current and will be permanently deleted after review is finalized. They will not be shared with {companyName}.",
            "uploadInstructions": "Please upload your school-issued document that shows:",
            "acceptableExamples": "Acceptable examples include:",
            "estimatedWaitTime": "a few minutes",
            "wsjRegular": 'Purchase a Membership at Our Normal Rate',
            "wsjRegularLink": '<a class="sid-upload-wsj-regular__link sid-link" href="https://subscribe.wsj.com/SheerIDcore" target="_blank">View Membership Options</a>',
            "rejectionReasons": {
                "DOCUMENT_UNREADABLE": "The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that's bright and crisp, and try submitting again.",
                "DOCUMENT_PASSWORD_PROTECTED": "We are unable to accept password protected documents.",
                "DOCUMENT_LIKELY_FRAUD": "The document you submitted is insufficient for establishing eligibility for this offer.",
                "DOCUMENT_UNSUPPORTED": "The document you submitted is not on the list of accepted document types.",
                "DOCUMENT_HANDWRITTEN": "We cannot accept handwritten documents.",
                "DOCUMENT_WORD_DOC": "We cannot accept text copied and pasted from official documents. Please submit a screenshot or image of the official document.",
                "MISSING_INFORMATION": "The document you submitted does not provide all of the information necessary to determine eligibility for this offer.",
                "MISSING_INFORMATION_PERSON_NAME": "The document you submitted is missing a first and/or last name.",
                "MISSING_INFORMATION_ORGANIZATION_NAME": "The document you submitted does not include an organization name that confirms your connection to that organization.",
                "DOCUMENT_EXPIRED": "The document you submitted has expired.",
                "DOCUMENT_OUTDATED": "The document you submitted is missing an issue date or was issued too far in the past.",
                "DOCUMENT_OUTDATED_LAST_3_MONTHS": "The document you submitted is missing an issue date or was issued more than three months ago.",
                "DOCUMENT_OUTDATED_LAST_6_MONTHS": "The document you submitted is missing an issue date or was issued more than six months ago.",
                "DOCUMENT_OUTDATED_LAST_12_MONTHS": "The document you submitted is missing an issue date or was issued more than twelve months ago.",
                "MISMATCH_PERSON_NAME": "The information on the document you submitted does not match the first and/or last name submitted on the verification form.",
                "MISMATCH_ORGANIZATION": "The organization name on the document(s) you submitted does not match the organization you listed on the verification form.",
                "MISMATCH_STATUS": "The status on the document you submitted does not match the status you listed on your verification form.",
                "INELIGIBLE_ORGANIZATION": "The organization on the document you submitted is not eligible for this offer.",
                "MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "The document you submitted does not prove enrollment in the current term.",
                "MISMATCH_SCHOOL_NAME": "The school name on the document you submitted does not match the school name listed on the verification form.",
                "INELIGIBLE_ORGANIZATION_UNIVERSITY_TITLE_IV": "The school listed on the document you submitted is not eligible for this offer because it is not a Title IV degree-granting college or university in the United States.",
                "INELIGIBLE_ORGANIZATION_US_UNIVERSITY": "The school listed in the document you submitted is not eligible for this offer because it is not in the United States.",
                "INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "High School Students are not eligible for this offer.",
                "MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.",
                "MISSING_INFORMATION_AFFILIATION_US_UNIFORMED_SERVICES": "The document you submitted does not show affiliation to an eligible branch of the United States Uniformed Services.",
                "MISMATCH_COMPANY_NAME": "The company name on the document you submitted does not match the company name you listed on the verification form.",
                "PAYSTUB_OUTDATED_LAST_30_DAYS": "Please upload a paystub that was issued within the last 30 days.",
                "PAYSTUB_OUTDATED_LAST_60_DAYS": "Please upload a paystub that was issued within the last 60 days.",
                "MISSING_INFORMATION_BIRTHDATE": "The document you submitted is missing a birthdate, or your age is ineligible for this offer.",
                "MISMATCH_BIRTHDATE": "The birthdate on the document you submitted does not match the birthdate you listed on the verification form.",
                "OTHER_CONTACT_US": "We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com",
                "PERSON_FIELD_MISMATCH": "A field in the document provided did not match with what was provided on the verification form."
            }
        },
        "pending": {
            "subtitle": "SheerID is reviewing your documents, to confirm your student status.",
            "title": "Processing",
            "subtitle2": "We will notify you via email of the outcome.",
            "maxReviewTime": "20 minutes"
        },
        "success": {
            "title": "Success",
            "subtitle": "You've been verified.<br><br>Your eligibility has been confirmed.<br>You are now eligible for a Wall Street Journal Student Membership.",
            "redirectUrl": null,
            "redirectButtonText": "CONTINUE",
            "continueButton": "Wall Street Journal",
        },
        "sso": {
            "title": "Unlock this Student-Only Offer",
            "subtitle": "Verify using your school credentials <br><br>Please sign in to your school's web portal. <br>It will open in a new tab.",
            "login": "LOG INTO MY SCHOOL",
            "details": "Information entered into this web form will be used for verification purposes. The information will be shared with The Wall Street Journal. Your information will be transferred to the United States and will be treated according to SheerID’s privacy policy.",
        }
    }
};
